import { canadaStates, mexicoStates, usStates } from "./states";

export const stateHelper = (countryId) => {
  let output = [];

  switch (countryId) {
    case "US":
      Object.entries(usStates).forEach(([key, value]) => {
        output.push(
          <option key={key} value={key}>
            {value}
          </option>
        );
      });
      break;

    case "Canada":
      Object.entries(canadaStates).forEach(([key, value]) => {
        output.push(
          <option key={key} value={key}>
            {value}
          </option>
        );
      });
      break;

    case "Mexico":
      Object.entries(mexicoStates).forEach(([key, value]) => {
        output.push(
          <option key={key} value={key}>
            {value}
          </option>
        );
      });
      break;
  }

  return output;
};
